import PrimaryProviderAssignmentPanel from './PrimaryProviderAssignmentPanel';

export default PrimaryProviderAssignmentPanel;
